'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deferAction = deferAction;
function deferAction(action) {
  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-focus-lock/dist/util.js
// module id = 356
// module chunks = 0